import { ReactElement, useCallback, useEffect, useState } from 'react';

import { ChronicDiseaseSimple } from '@dreryk/egabinet-patient-medical-information-frontend-api';
import { Visit, VisitQuery } from '@dreryk/egabinet-visit-frontend-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';
import { useBoolean } from '@dreryk/react-common';

import { PrescriptionVisitDataModal } from './PrescriptionVisitDataModal';
import { registerShowPrescriptionVisitDataModalEventListener } from './PrescriptionVisitDataModal.event';

type PrescriptionVisitDataModalOpenerRenderProps = { openModal: VoidFunction };

type PrescriptionVisitDataModalOpenerProps = {
   readonly visit: Visit;
   readonly chronicDiseases: ChronicDiseaseSimple[];
   readonly children: (renderProps: PrescriptionVisitDataModalOpenerRenderProps) => ReactElement;
};

export const PrescriptionVisitDataModalOpener = (props: PrescriptionVisitDataModalOpenerProps): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);
   const [validateOnOpen, setValidateOnOpen] = useState(false);

   const handleOpen = useCallback(async (): Promise<void> => {
      await refetchCqrsQuery(VisitQuery);
      openModal();
   }, [openModal]);

   const handleClose = async (): Promise<void> => {
      setValidateOnOpen(false);
      closeModal();
      await refetchCqrsQuery(VisitQuery);
   };

   useEffect(
      () =>
         registerShowPrescriptionVisitDataModalEventListener(async () => {
            setValidateOnOpen(true);
            await handleOpen();
         }),
      [handleOpen]
   );

   return (
      <>
         {props.children({ openModal: handleOpen })}
         {modalOpened ? (
            <PrescriptionVisitDataModal
               visit={props.visit}
               chronicDiseases={props.chronicDiseases}
               validateOnOpen={validateOnOpen}
               onClose={handleClose}
            />
         ) : null}
      </>
   );
};
